import {ApiSortOrder, ApiSortsDerived} from '@/api/meta/odata';
import {getOrders} from '@/api/module/order';
import Order, {ApiOrder, OrderFilters} from '@/model/Order';
import {createVersionedStorage} from './types';
import {ValueType} from '@/api/meta/filters';
import {JNToDisplay, toDisplay} from '@/util/store';

export const filterNames: Record<keyof OrderFilters, string | null> = {
  'Nummer': 'Bestell-Nr.',
  'Erledigt': null,
  'Termine/GeplantLieferDatum$From': 'geplantes Lieferdatum von',
  'Termine/GeplantLieferDatum$To': 'geplantes Lieferdatum bis',
  'Lieferant/LieferantNr': 'Lieferantennr.',
  'Lieferant/LieferantName$Contains': 'Lieferantenname',
  'Fulltext$Fulltext': 'Suche',
};

const useOrdersStore = createVersionedStorage<
  OrderFilters, ApiSortsDerived<ApiOrder>, Order[]
>('orders', {
  fetchFn: getOrders,
  defaultData: [],
  defaultFilters: {
    Erledigt: 'N',
    Fulltext$Fulltext: {
      words: [],
      fields: [
        {
          path: ['Nummer'],
          valueType: ValueType.NumberStartsWith,
        },
        {
          path: ['Lieferant/LieferantNr'],
          valueType: ValueType.NumberStartsWith,
        },
        {
          path: ['Lieferant/LieferantName'],
          valueType: ValueType.StringContains,
        },
      ],
    },
  },
  defaultSorts: [
    ['Termine/GeplantLieferDatum' as keyof ApiOrder, ApiSortOrder.Asc],
  ],
  alwaysSorted: [],
  defaultLimit: 50,
  formatter: {
    'Nummer': toDisplay('Bestell-Nr.'),
    'Termine/GeplantLieferDatum$From': toDisplay('geplantes Lieferdatum von'),
    'Termine/GeplantLieferDatum$To': toDisplay('geplantes Lieferdatum bis'),
    'Lieferant/LieferantNr': toDisplay('Lieferantennr.'),
    'Lieferant/LieferantName$Contains': toDisplay('Lieferantenname'),
    'Erledigt': JNToDisplay('erledigt', 'offen'),
  },
  // convertFilterToDisplayFn: createConvertFiltersToDisplayFn(
  //     createGetRowFn({
  //       getLabel: ({actualKeys}) => filterNames[actualKeys[0] as keyof OrderFilters],
  //     }),
  // ),
});

export default useOrdersStore;
